module.exports = __webpack_public_path__ + "static/media/banner1.92f491d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/nordlock/images/banner1.jpg
// module id = 552
// module chunks = 0